import React from 'react';
import { omit } from 'lodash';
import { ComponentType } from 'react';

export const OmitProps = <P extends object, K extends keyof any>(
  Component: ComponentType<P>,
  propsToOmit: K[],
) => {
  return React.forwardRef<any, Omit<P, K>>((props, ref) => {
    const filteredProps = omit(props, propsToOmit);
    return <Component ref={ref} {...(filteredProps as P)} />;
  });
};
